import React, {  } from 'react';
import { Map } from '@components/icon/icon'
import { Link } from 'gatsby';

function GetmapLink(props) {
    const OpenMap= () => {
        const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
        const mapUrl = currentUrl.replace("property", "property-map")
        if (typeof window !== "undefined") {
            window.location = mapUrl
        }
    }
    return (
        <a className="text-20-16 utils-nav-item utils-nav-item-map" href="javascript:;" onClick={(e)=>OpenMap()}><Map /><span>Map</span></a>
    )
}
export default GetmapLink
